
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Website,
  WebsiteCreation,
  WebsiteDeletion,
  WebsiteOrchestratorResourcesInterface,
} from '@/services/Website/interfaces';
import { WebsiteMigration } from '@/services/WebsiteMigrations/interfaces';
import StatusChip from '@/components/layout/StatusChip.vue';

@Component({
  components: { StatusChip },
})
export default class WebsiteActivityResult extends Vue {
  @Prop({ type: Object, required: true })
  public website!: Website;

  @Prop({ type: Object, required: true })
  public resources!: WebsiteOrchestratorResourcesInterface;

  public get creations(): WebsiteCreation[] {
    return this.resources.creations || [];
  }

  public get deletions(): WebsiteDeletion[] {
    return this.resources.deletions || [];
  }

  public get migrations(): WebsiteMigration[] {
    return this.resources.migrations || [];
  }
}
